import type { CareerPathAiImpact, CareerPathAIDisruption } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.careerPath.detailPage.aiImpact;

export const useAgentContext = (
  aiImpact: CareerPathAiImpact,
  careerPathAIDisruption: CareerPathAIDisruption,
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Impact of AI',
    description:
      'How AI is expected to affect this career path — overall disruption score and breakdown by dimension with expandable descriptions.',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'AI Disruption Score',
    display:
      'Card with overall AI disruption rating and progress bar charts (out of 5) for each impact dimension, plus expandable accordion sections with detailed descriptions per dimension',
    detail: `Modal description: "${STRINGS.aiImpactDescription}" Dimensions: Automation Risk — "${STRINGS.descriptions.automationRisk}", AI Integration Intensity — "${STRINGS.descriptions.integrationIntensity}", Role Reinvention Needed — "${STRINGS.descriptions.roleReinventionNeed}", AI Leverage Upside — "${STRINGS.descriptions.leverageUpside}", Human Differentiator Index — "${STRINGS.descriptions.humanDifferentiatorIndex}"`,
    data: {
      overall_ai_impact: aiImpact,
      disruption_scores: careerPathAIDisruption,
    },
  });
};
